import logoSE from '../assets/img/se.jpg'
import logoDK from '../assets/img/dk.jpg'
import logoFI from '../assets/img/fi.jpg'
import logoNO from '../assets/img/no.jpg'
import { Countries } from '../models/countries'

export const getCountryFlag = countryCode => {
  switch (countryCode) {
    case Countries.SE:
      return logoSE
    case Countries.DK:
      return logoDK
    case Countries.FI:
      return logoFI
    case Countries.NO:
      return logoNO
    default:
      return null
  }
}

const LocalCountryName = {
  SE: 'Sverige',
  DK: 'Danmark',
  NO: 'Norge',
  FI: 'Suomi',
}

export const translateCountryCodeToLocalCountryName = countryCode => {
  switch (countryCode) {
    case Countries.SE:
      return LocalCountryName.SE
    case Countries.DK:
      return LocalCountryName.DK
    case Countries.FI:
      return LocalCountryName.FI
    case Countries.NO:
      return LocalCountryName.NO
    default:
      return countryCode
  }
}
